import { z } from "zod";

// Form `data` is a nested JSON blob; events carry the fully-computed record the
// router built. `auditDetails` is the raw details object for the form_audit_logs
// timeline (the router built it; the projector serialises it).
const formData = z.record(z.string(), z.unknown());
const auditDetails = z.record(z.string(), z.unknown()).nullable().optional();

export const formDrafted = z.object({
  type: z.literal("FormDrafted"),
  formId: z.string().min(1),
  siteId: z.string().min(1),
  templateId: z.string().min(1),
  createdBy: z.string().min(1),
  assignedTo: z.string().nullable().optional(),
  data: formData,
  aiContext: z.unknown().optional(),
  auditDetails,
});

export const formUpdated = z.object({
  type: z.literal("FormUpdated"),
  formId: z.string().min(1),
  data: formData,
  aiContext: z.unknown().optional(),
  changedFields: z.array(z.string()).optional(),
  auditDetails,
});

export const formSubmittedForReview = z.object({
  type: z.literal("FormSubmittedForReview"),
  formId: z.string().min(1),
  data: formData,
  submittedAt: z.date(),
  auditDetails,
});

export const formApproved = z.object({
  type: z.literal("FormApproved"),
  formId: z.string().min(1),
  data: formData,
  approvedAt: z.date(),
  auditDetails,
});

export const formRejected = z.object({
  type: z.literal("FormRejected"),
  formId: z.string().min(1),
  data: formData,
  rejectedBy: z.string().min(1),
  rejectedAt: z.date(),
  rejectionReason: z.string(),
  rejectionMessage: z.string().nullable().optional(),
  auditDetails,
});

export const formClosed = z.object({
  type: z.literal("FormClosed"),
  formId: z.string().min(1),
  data: formData,
  closedAt: z.date(),
  auditDetails,
});

export const formAttachmentUploaded = z.object({
  type: z.literal("FormAttachmentUploaded"),
  formId: z.string().min(1),
  attachmentId: z.string().min(1),
  fileKey: z.string().min(1),
  fileType: z.string().min(1),
  uploadedBy: z.string().min(1),
});

export const formAiSuggestionRequested = z.object({
  type: z.literal("FormAiSuggestionRequested"),
  formId: z.string().min(1),
  suggestionId: z.string().min(1),
  inputText: z.string(),
});

export const formAiSuggestionProduced = z.object({
  type: z.literal("FormAiSuggestionProduced"),
  formId: z.string().min(1),
  suggestionId: z.string().min(1),
  output: z.record(z.string(), z.unknown()),
  confidence: z.number().nullable().optional(),
});

export const formEvents = [
  formDrafted,
  formUpdated,
  formSubmittedForReview,
  formApproved,
  formRejected,
  formClosed,
  formAttachmentUploaded,
  formAiSuggestionRequested,
  formAiSuggestionProduced,
] as const;
